import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=f49f07f4&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/shared/Header/HeaderStylePublic.css?vue&type=style&index=0&id=f49f07f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49f07f4",
  null
  
)

export default component.exports